/* Module Type Mappings */
export const ModuleTypes = {
  anchorLink: 'paragraph--anchor',
  internalLink: 'menu--element',
  nodePage: 'node--page',
  introduction: 'paragraph--introduction',
};

/* Modal Settings */
export const DeleteModalSettings = {
  type: 'confirm',
  headline: 'Please confirm',
  text: 'Do you really want to delete this item?',
  width: '460px',
  height: '260px',
  onConfirmationClick: null,
};

export const DeleteDraftSettings = {
  type: 'confirm',
  headline: 'Please confirm',
  text: 'Do you really want to delete this draft?',
  width: '460px',
  height: '260px',
  onConfirmationClick: null,
};

/* URL replacement */
export enum URL_REPLACEMENT {
  BACKEND_URL = '__backendUrl__',
  SYMFONY_URL = '__symfonyUrl__',
  API_BASE = '__apiBase__',
}

/* Anchors */
export const ANCHOR_PREFIX = 'anchor-';
export const ANCHOR_TOP_ID = `${ANCHOR_PREFIX}-top`;

/* Media-Library */
export const DEFAULT_MEDIA_LIBRARY_REALM = 'asset_library';
export const URL_PARAM_ASSETID = 'AssetId';
export const URL_PARAM_COLLECTION = 'Collection';
